import styled, { css, keyframes } from 'styled-components';
import { Button, Form } from 'reactstrap';

export { InputWrapper, ToggleVisibilityButton } from '../Login/styles';

const rotate = keyframes`
from {
  transform: rotate(0deg);
}
to {
  transform: rotate(360deg);
}
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  max-width: 540px;
  margin: 0px auto;
  padding: 0 16px;
`;

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .form-group {
    margin-bottom: 0;
  }
`;

export const ButtonSubmit = styled(Button).attrs(props => ({
  disabled: !!props.loading,
}))`
  margin-top: 8px;
  &[disabled] {
    cursor: not-allowed;
    opacity: 0.6;
  }

  ${props =>
    props.loading &&
    css`
      svg {
        margin-left: 10px;
        animation: ${rotate} 2s linear infinite;
      }
    `}
`;
